import React from 'react'
import { Button, Col, Row, Dropdown } from 'react-bootstrap'
import {
  i18nTranslate,
  trackGTMEvents,
  enablePdpRedesign,
  isValidUrl,
} from 'src/utils'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import { observer } from 'mobx-react'
import { COLOR_BASED_VARIANT_NODES } from 'config/appConfig'
import { imagePlaceholder } from 'src/static/fixtures/imagePlaceholder'
import colorCode from 'src/static/fixtures/colorCode.json'
import { Icons } from 'src/views/components'
import { PDPContext } from 'src/views/components/BaseProductComponent'
import { productDeps } from 'src/deps'
import { GrClose as CloseIcon } from 'react-icons/gr'
import { IoCheckmarkCircle, IoChevronDown } from 'react-icons/io5'
import './styles.scss'
import { observable, action } from 'mobx'

@observer
class V2ProductOption extends React.Component {
  @observable isHandleGTMEventFire = false
  constructor(props) {
    super(props)
    this.state = {
      showMobileDropdown: false,
    }
  }

  handleMobileDropdownToggle = isOpen => {
    this.setState({ showMobileDropdown: isOpen })
  }

  static contextType = PDPContext
  static defaultProps = {
    selectionType: 'border',
  }

  filterByVariantLabel = variantType => {
    const skuList = this.props?.skuList || []
    return skuList.filter(
      item => item?.properties?.variantLabel === variantType
    )
  }
  handleGTMeventFireForMultivariant = ({
    variantType = '',
    replacementProduct = '',
  }) => {
    const selectedSkuData = this.filterByVariantLabel(variantType)

    trackGTMEvents({
      event: 'MultiVariant',
      ecommerce: {
        click: {
          actionField: {
            list: this.props?.isQuickViewModal ? 'PLP quickview' : 'PDP',
            action: 'click',
            products: [
              {
                variant_type: variantType,
                name: selectedSkuData?.[0]?.properties?.name || '',
                id: selectedSkuData?.[0]?.identifier,
                price: selectedSkuData?.[0]?.price || '',
                replacement_product: replacementProduct,
              },
            ],
          },
        },
      },
    })
  }
  handleVariantClick = () => {
    this.isHandleGTMEventFire = true
  }
  componentDidUpdate(prevProps) {
    if (this.isHandleGTMEventFire) {
      this.handleGTMeventFireForMultivariant({
        variantType: this.props?.skuSelected?.variantLabel || '',
        replacementProduct: this.props?.isReplacementProductArray
          ? 'available'
          : 'not available',
      })
      this.isHandleGTMEventFire = false
    }
  }

  mobileDropdown = (key, values) => {
    const { skuSelected = {} } = this.props
    const type = key.type
    const selectedValue = skuSelected[type]
    const selectedOption = values.find(v => v.label === selectedValue)

    return (
      <div className="mobile-options d-md-none">
        <div className="mobile-option-dropdown">
          <Dropdown
            show={this.state.showMobileDropdown}
            onToggle={isOpen => {
              this.setState({ showMobileDropdown: isOpen })
            }}
            drop="up">
            <Dropdown.Toggle
              className="mobile-dropdown-toggle"
              id={`dropdown-${type}`}
              bsPrefix="btn">
              <span className="mobile-dropdown-text">
                {selectedOption ? selectedOption.label : 'Select option'}
              </span>
              <IoChevronDown
                size="16px"
                color="#666666"
                className="mobile-dropdown-icon"
                style={{
                  transform: this.state.showMobileDropdown
                    ? 'rotate(180deg)'
                    : 'rotate(0deg)',
                }}
              />
            </Dropdown.Toggle>

            <Dropdown.Menu className="mobile-dropdown-menu">
              {values.map((option, index) => {
                const shouldDisable =
                  option.disable === true ||
                  (this.props.isFromSubscription && !option.isSubscribable)
                const isSelected = selectedValue === option.label

                return (
                  <Dropdown.Item
                    key={index}
                    className={`mobile-dropdown-item ${isSelected ? 'selected' : ''} ${shouldDisable ? 'disabled' : ''}`}
                    disabled={shouldDisable}
                    style={{
                      cursor: shouldDisable ? 'not-allowed' : 'pointer',
                      opacity: shouldDisable ? 0.5 : 1,
                      borderBottom:
                        index < values.length - 1 ? '1px solid #eee' : 'none',
                    }}
                    onClick={e => {
                      e.stopPropagation()
                      if (!shouldDisable) {
                        this.props.handleSkuSelection &&
                          this.props.handleSkuSelection({
                            type,
                            value: option.label,
                            identifier: option.identifier || '',
                          })
                        const context = this.context
                        productDeps.changeVariantInUrlForPDP(
                          context,
                          option.variantForUrl || '',
                          this.props
                        )
                        this.handleVariantClick()
                        this.setState({ showMobileDropdown: false })
                      }
                    }}>
                    <div className="mobile-dropdown-item-section">
                      <span className="mobile-dropdown-item-text">
                        {option.label}
                      </span>
                      {isSelected && (
                        <IoCheckmarkCircle
                          className="mobile-dropdown-checkmark"
                          size="20px"
                        />
                      )}
                    </div>
                  </Dropdown.Item>
                )
              })}
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>
    )
  }
  render() {
    const disableSkuSelectionClass = this.props.disableSkuSelection
      ? 'disable-selection'
      : ''
    const { options = [], skuSelected = {}, selectionType } = this.props

    if (!options || options.length === 0) {
      return null
    }

    const skuGroup = options.map(key => {
      const isColorBasedSku = COLOR_BASED_VARIANT_NODES.includes(
        key.type.toLowerCase()
      )

      const buttonGroup = (values, index) => {
        const value = values.label
        const type = key.type
        const identifier = values.identifier || ''
        const shouldDisable =
          values.disable === true ||
          (this.props.isFromSubscription && !values.isSubscribable)
        const padding = isColorBasedSku ? 'p-1' : ''
        const isDiscontinuedClass = this.props?.isProductDiscontinuedStatus
          ? ' discontinued '
          : ''
        const className = shouldDisable
          ? ' disabled'
          : skuSelected[type] === value
            ? enablePdpRedesign()
              ? ` selected new-option-selected ${padding}`
              : selectionType === 'border' || isColorBasedSku
                ? ` selected border-primary text-primary sku-border-thick font-weight-bold ${padding}`
                : ` selected bg-primary border-0 text-white font-weight-bold ${padding}`
            : enablePdpRedesign()
              ? ` new-option-unselected ${padding}`
              : ` ${padding}`

        const attribute = {
          className: type + className + isDiscontinuedClass + 'w-100',
          key: `${key.type}_${index}`,
        }

        return (
          <Button
            {...attribute}
            variant="outline-secondary"
            data-testid="qa-facet"
            onClick={() => {
              this.props.handleSkuSelection &&
                this.props.handleSkuSelection({ type, value, identifier })
              const context = this.context
              /* @variant labelchange */

              productDeps.changeVariantInUrlForPDP(
                context,
                values.variantForUrl || '',
                this.props
              )
              this.handleVariantClick()
            }}>
            {/*Selected variant tick icon*/}
            {skuSelected[type] === value ? (
              this.props?.isProductDiscontinuedStatus ? (
                <CloseIcon
                  className="variant-selected-discontinued-icon mr-2"
                  size="24px"
                  color="#C81D1D"
                />
              ) : enablePdpRedesign() ? (
                <IoCheckmarkCircle
                  className="variant-selected-icon mr-2"
                  size="20px"
                  color="#000000"
                />
              ) : (
                <Icons
                  name="CRUD"
                  icontype="tick-v2"
                  viewBox="0 0 24 17"
                  className="variant-selected-icon mr-2"
                  width="24px"
                  height="24px"
                  color="#252525"
                />
              )
            ) : null}

            {isColorBasedSku ? (
              isValidUrl(values.url) ? (
                <LazyLoadImage
                  src={values.url || imagePlaceholder}
                  alt={values.label}
                  className={'align-top'}
                  onError={e => {
                    if (e.target.src != imagePlaceholder) {
                      e.target.onerror = null
                      e.target.src = imagePlaceholder
                    }
                  }}
                />
              ) : (
                <div
                  className="border"
                  style={{
                    background: colorCode[value],
                    height: '25px',
                    width: '25px',
                  }}
                />
              )
            ) : (
              // <Image
              //   className="align-top"
              //   src={values.url}
              //   onError={e => (e.target.src = imagePlaceholder)}
              //   alt={values.label}
              // />
              <span className="variant-label"> {value}</span>
            )}
          </Button>
        )
      }
      return (
        <section
          key={`product-option-${key.type}`}
          data-testid={`qa-select-${key.type}`}
          className={`product-option-list align-items-center ${disableSkuSelectionClass} w-100`}>
          {!enablePdpRedesign() && key.values.length > 1 && (
            <Row noGutters className="align-items-center product-option-title">
              <div className="select-heading mb-2">
                <p>
                  <span style={{ fontWeight: 'bold' }}>
                    {key?.values?.length > 1
                      ? i18nTranslate(
                          'product.selectOption',
                          'Select your option',
                          {
                            nameSpace: 'ssr-resource',
                          }
                        ) + ': '
                      : i18nTranslate('product.yourOption', 'Your option') +
                        ': '}
                  </span>
                </p>
              </div>
              {key.type && (
                <label className="sku-option pl-1 mb-2">
                  {skuSelected[key.type]}
                </label>
              )}
            </Row>
          )}

          {enablePdpRedesign() ? (
            <div className="new-ui-options-section">
              <div className="option-label">
                {i18nTranslate('product.selectOption', 'Select your option', {
                  nameSpace: 'ssr-resource',
                }) + ': '}
                <strong>{skuSelected[key.type] || 'Normal/Combo'}</strong>
              </div>

              <div className="option-buttons-container d-none d-md-block">
                <div className="main-options">
                  {key.values.map((option, index) => (
                    <button
                      key={`${key.type}_${index}`}
                      className={`option-btn ${
                        skuSelected[key.type] === option.label ? 'selected' : ''
                      }`}
                      onClick={() => {
                        this.props.handleSkuSelection &&
                          this.props.handleSkuSelection({
                            type: key.type,
                            value: option.label,
                            identifier: option.identifier || '',
                          })
                        const context = this.context
                        productDeps.changeVariantInUrlForPDP(
                          context,
                          option.variantForUrl || '',
                          this.props
                        )
                        this.handleVariantClick()
                      }}>
                      {skuSelected[key.type] === option.label && (
                        <IoCheckmarkCircle className="checkmark" />
                      )}
                      {option.label}
                    </button>
                  ))}
                </div>
              </div>
            </div>
          ) : (
            <Col
              noGutters
              className={`product-options ${key.type}-wrapper old-pdp-options d-none d-md-block`}
              aria-label={i18nTranslate(
                'productDetails.skuOption',
                'Sku Options',
                {
                  nameSpace: 'ssr-resource',
                }
              )}>
              {key.values.length > 1 &&
                key.values.map((keyObj, index) => (
                  <div
                    key={`old-${index}`}
                    className={`variantLabel-container`}>
                    {buttonGroup(keyObj, index)}
                  </div>
                ))}
            </Col>
          )}

          {enablePdpRedesign() && this.mobileDropdown(key, key.values)}
          {this.props.showError && this.props.showError(key.type)}
        </section>
      )
    })
    return skuGroup
  }
}

export { V2ProductOption }
export default V2ProductOption
